<template>
  <div class="wrapper">
    <div class="container">
      <div class="content-wrapper">
        <div class="group-content" style="height: 100vh;display: inline-flex;justify-content: center;align-items: center;width: 100%;">
            <h1>Đang chờ duyệt từ quản trị viên</h1>
        </div>
      </div>
    </div>
    <BaseFormLoading :loading="loading"></BaseFormLoading>
  </div>
</template>
<script>

import BaseFormLoading from './base/BaseFormLoading'

export default {
  name: 'Verify',
  components: {BaseFormLoading},
  data: function () {
    return {
      loading: true,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {},
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/views/Verify.vue